import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { mpfNewsByThemeSchema } from './schema';

const Data = (props: any) => {
  const { block, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfNewsByThemeSchema({ intl, data });

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id: string, value: unknown) =>
        onChangeBlock(block, { ...data, [id]: value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
